export default {
    QuarterlyServices: "Quarterly Services",
    MeteredServices: "Metered Services",
	Paper: "Cut Sheet Paper",
	LfpPaper: "Lfp Roll Fed Media",
	LfpProductsAndServices: "Lfp Products And Services",
	LfpInkUsageTypes: "Lfp Ink Usage Types"
}